import { FC } from 'react';

// ─────────────────────────────────────────────
// MariShareLegend
//
// 마리 수익금(1%)이 붙는 표 아래 범례. 헷갈리면 안 되는 두 줄만 남긴다.
//   ①    = 상조가 끊는 세금계산서 → 상조로 입금
//   ①+②  = 마리가 가온프라임 앞으로 끊는 세금계산서 → 가온이 입금
// admin·마리 화면 전용(상조 화면에는 이 컴포넌트를 마운트하지 않는다).
// ─────────────────────────────────────────────

const Tag: FC<{ children: string; tone: string }> = ({ children, tone }) => (
  <span className={`rounded border px-1.5 py-0.5 text-xs font-bold tabular-nums ${tone}`}>
    {children}
  </span>
);

export interface MariShareLegendProps {
  /** 쿠폰형 ②가 서버 건별 합이 아니라 근사 폴백인 경우 (한 줄 꼬리표만 붙인다) */
  approximate?: boolean;
}

export const MariShareLegend: FC<MariShareLegendProps> = ({ approximate = false }) => (
  <div className="rounded-lg border border-gray-200 bg-gray-50 px-4 py-3">
    <div className="flex flex-wrap items-center gap-2 text-sm">
      <Tag tone="border-gray-300 bg-white text-gray-700">①</Tag>
      <b className="text-gray-800">상조 정산금</b>
      <span className="text-gray-500">
        = 상조에게 받을 세금계산서 금액 · <b className="text-gray-800">상조로 입금</b>
      </span>
    </div>
    <div className="mt-2 flex flex-wrap items-center gap-2 text-sm">
      <Tag tone="border-purple-300 bg-purple-50 text-purple-700">①+②</Tag>
      <b className="text-gray-800">계산서 총액</b>
      <span className="text-gray-500">
        = <b className="text-gray-800">가온프라임</b>에 끊어줄 세금계산서 금액 ·{' '}
        <b className="text-gray-800">가온이 입금</b>
      </span>
    </div>
    <p className="mt-2 text-xs text-gray-400">
      ② 마리 수익금 = 판매가의 1% · 전액 <b>과세</b>(부가세 포함)
      {approximate && ' · 쿠폰형 ②는 서버 반영 전 근사치'}
    </p>
  </div>
);
